import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { getBoatsByRegatta } from "../../../../api/boat";
import { alertError } from "../../../../utils/logger";
import RankingDialog from "../../../components/dialogs/RankingDialog";
import Table, {
	booleanFormatter,
	imageFormatter,
	timeFormatter,
} from "../../../components/tables/table";

function getData(boats) {
	let data = [];
	for (let i = 0; i < boats.length; ++i) {
		const elem = {};
		elem.boat = boats[i].fullName;
		elem.image = boats[i].image;
		elem.boatNumber = boats[i].boatNumber;
		elem.boatClass = boats[i].boatClass;
		elem.time = boats[i].time;
		elem.finished = boats[i].finished;
		elem.id = boats[i]._id;
		data = data.concat(elem);
	}

	return data;
}

export default function RankingRegattasPage() {
	const [data, setData] = useState([]);
	const [dataList, setDataList] = useState([]);
	const [refresh, setRefresh] = useState(false);
	const [openRankingDialog, setOpenRankingDialog] = useState(null);
	const regattaId = useParams().id;

	const columns = [
		{
			dataField: "image",
			text: "",
			formatter: imageFormatter,
		},
		{
			dataField: "boat",
			text: "Boat",
			sort: true,
		},
		{
			dataField: "boatNumber",
			text: "Boat number",
			sort: true,
		},
		{
			dataField: "boatClass",
			text: "Boat class",
			sort: true,
		},
		{
			dataField: "time",
			text: "Total time",
			headerAlign: "center",
			align: "center",
			formatter: timeFormatter,
			sort: true,
		},
		{
			dataField: "finished",
			text: "Finished",
			headerAlign: "center",
			align: "center",
			formatter: booleanFormatter,
			sort: true,
		},
	];

	useEffect(() => {
		getBoatsByRegatta(regattaId)
			.then((res) => {
				if (res.status === 200) {
					setDataList(getData(res.data));
					setData(res.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get ranking.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Ranking">
					<CardHeaderToolbar>
						<button
							className={
								"btn btn-primary font-weight-bold my-3 align-self-center"
							}
							onClick={() => setOpenRankingDialog(true)}
						>
							Ranking Final
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={dataList} columns={columns} />
				</CardBody>
			</Card>
			<RankingDialog
				title={"Ranking final"}
				open={openRankingDialog}
				setOpen={setOpenRankingDialog}
				data={data}
			/>
		</>
	);
}
